import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Collapse } from "react-collapse";
import Icon from "@/components/ui/Icon";
import BotSelector from "@/components/partials/sidebar/BotSelector.tsx";
import Branding from "@/utils/branding";
import { useSidebar } from "@/components/shadcn/sidebar";

const Navmenu = ({ menus }) => {
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const sidebarCtx = useSidebar();

  const toggleSubmenu = (i) => {
    if (activeSubmenu === i) {
      setActiveSubmenu(null);
    } else {
      setActiveSubmenu(i);
    }
  };

  const location = useLocation();
  const locationName = location.pathname.replace("/", "");

  useEffect(() => {
    let submenuIndex = null;
    menus.map((item, i) => {
      if (!item.child) return;
      if (item.link === locationName) {
        submenuIndex = null;
      } else {
        const ciIndex = item.child.findIndex(
          (ci) => ci.childlink === locationName,
        );
        if (ciIndex !== -1) {
          submenuIndex = i;
        }
      }
    });
    document.title = `${Branding().name} | ${locationName}`;

    setActiveSubmenu(submenuIndex);
  }, [location]);

  return (
    <>
      <ul>
        {menus.map((item, i) => (
          <li
            key={i}
            className={` single-sidebar-menu 
              ${item.child ? "item-has-children" : ""}
              ${activeSubmenu === i ? "open" : ""}
              ${locationName === item.link ? "menu-item-active" : ""}`}
          >
            {item.isSelector && <div className="">{item.content}</div>}

            {/* single menu with no childred*/}
            {!item.child && !item.isHeadr && (
              <NavLink
                className={
                  "menu-link " + (sidebarCtx.open ? "" : "!py-2 !px-0")
                }
                to={item.link}
                onClick={item.onclick ? item.onclick : () => {}}
              >
                <div className="menu-icon flex-grow-0 pl-1 w-8 flex justify-center">
                  <div>
                    <Icon
                        icon={item.icon}
                        width={item.iconSize ? item.iconSize : "25px"}
                        className={
                          item.iconExtraClasses !== undefined
                              ? item.iconExtraClasses
                              : ""
                        }
                    />
                  </div>
                </div>
                {sidebarCtx.open && (
                  <div className="text-box flex-grow">
                    {item.title}
                    {item.isNew && (
                      <span className="inline-block ml-4 bg-primary-500 text-white rounded py-1 px-2 lowercase text-sm">
                        new
                      </span>
                    )}
                  </div>
                )}
                {item.badge && <span className="menu-badge">{item.badge}</span>}
              </NavLink>
            )}
            {/* only for menulabel */}
            {sidebarCtx.open && item.isHeadr && !item.child && (
              <div className="menulabel pl-2">{item.title}</div>
            )}
            {/*    !!sub menu parent   */}
            {sidebarCtx.open && item.isBotSelector && <BotSelector />}
            {item.child && (
              <div
                className={`menu-link ${
                  activeSubmenu === i
                    ? "parent_active not-collapsed"
                    : "collapsed"
                }`}
                onClick={() => toggleSubmenu(i)}
              >
                <div className="flex-1 flex items-start">
                  <span className="menu-icon">
                    <Icon icon={item.icon} />
                  </span>
                  <div className="text-box">{item.title}</div>
                </div>
                <div className="flex-0">
                  <div
                    className={`menu-arrow transform transition-all duration-300 ${
                      activeSubmenu === i ? " rotate-90" : ""
                    }`}
                  >
                    <Icon icon="heroicons-outline:chevron-right" />
                  </div>
                </div>
              </div>
            )}
            <Collapse isOpened={activeSubmenu === i}>
              <ul className="sub-menu ">
                {item.child?.map((subItem, j) => (
                  <li key={j} className="block pl-4 pr-1 mb-4 first:mt-4">
                    <NavLink to={subItem.childlink}>
                      {({ isActive }) => (
                        <span
                          className={`${
                            isActive
                              ? " text-black dark:text-white font-medium"
                              : "text-slate-600 dark:text-slate-300"
                          } text-sm flex space-x-3 items-center transition-all duration-150`}
                        >
                          <span
                            className={`${
                              isActive
                                ? " bg-slate-900 dark:bg-slate-300 ring-4 ring-opacity-[15%] ring-black-500 dark:ring-slate-300 dark:ring-opacity-20"
                                : ""
                            } h-2 w-2 rounded-full border border-slate-600 dark:border-white inline-block flex-none`}
                          ></span>
                          <span className="flex-1">{subItem.childtitle}</span>
                        </span>
                      )}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </Collapse>
          </li>
        ))}
      </ul>
    </>
  );
};

export default Navmenu;
